export enum ModelCitizensFeatureFlags {
    EnableWfdAgent = 'enable-wfd-agent'
}
